<template>
  <div class="flex items-center justify-center min-h-dvh col-span-12">
    <div class="loader w-12 aspect-square p-2 rounded-full animate-spin"></div>
  </div>
</template>

<script>
export default {
  name: "LoaderComponent",
};
</script>

<style scoped>
.loader {
  background: var(--ink);
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}
</style>
